<form [formGroup]="formGroup" fxLayoutAlign="center center">
  <div fxLayout="column" fxLayoutGap="25px" class="wrapper">
 
    <div fxFlex fxLayout fxLayout.lt-md="column" fxLayoutGap="15px">
      <div fxFlex="50" class="padding-5">
        <mat-card fxLayout="column">
          <mat-card-title id="id_dist_form_header">
            {{ 'LABEL_DISTRIBUTION_DETAILS' | translate }}
          </mat-card-title>
 
          <!-- code -->
          <mat-form-field>
            <input 
              id="id_dist_code_txtbox"
              #code 
              matInput
              required
              autocomplete="off" 
              formControlName="code" 
              [placeholder]="'LABEL_CODE' | translate"
              >  
          </mat-form-field>

          <!-- description -->
          <mat-form-field>
            <input 
              i="id_dist_name_txtbox"
              matInput
              required
              #description 
              autocomplete="off" 
              formControlName="description" 
              [placeholder]="'LABEL_DESCRIPTION' | translate"
              >
 
            <mat-error *ngIf="formGroup.controls['description'].hasError('required')">
              {{ 'MSG_FIELD_REQUIRED' | translate }}
            </mat-error> 
            
            <mat-error *ngIf="formGroup.controls['description'].hasError('maxlength')">
              {{ 'MSG_MAXLENGTH' | translate: {length: '250'} }}
            </mat-error>

            <mat-error *ngIf="formGroup.controls['description'].hasError('exists')">
              {{ 'MSG_DISTRIBUTION_NAME_EXISTS' | translate }}
            </mat-error>
          </mat-form-field>
 
          <!-- red_start_date -->
          <mat-form-field>
            <input 
              id="id_dist_red_start_date"
              matInput 
              required 
              readonly
              [min]="minDate" 
              [max]="maxDate"
              (click)="red_start_date.open()" 
              [matDatepicker]="red_start_date" 
              formControlName="red_start_date" 
              [placeholder]="'LABEL_REDEMPTION_START_DATE' | translate" 
              >
 
            <mat-datepicker-toggle id="id_dist_red_start_date_btn" matSuffix [for]="red_start_date"></mat-datepicker-toggle>
            <mat-datepicker #red_start_date></mat-datepicker>
            
            <mat-error *ngIf="formGroup.controls['red_start_date'].hasError('required')">
              {{ 'MSG_FIELD_REQUIRED' | translate }}
            </mat-error>    
          </mat-form-field>
 
          <!-- red_end_date -->
          <mat-form-field>
            <input 
              id="id_dist_red_end_date"
              matInput 
              required 
              readonly
              (click)="red_end_date.open()" 
              [matDatepicker]="red_end_date" 
              formControlName="red_end_date" 
              [min]="formGroup.get('red_start_date').value || minDate" 
              [placeholder]="'LABEL_REDEMPTION_END_DATE' | translate" 
              >
 
            <mat-datepicker-toggle id="id_dist_red_end_date_btn" matSuffix [for]="red_end_date"></mat-datepicker-toggle>
            <mat-datepicker #red_end_date></mat-datepicker>  
 
            <mat-error *ngIf="formGroup.controls['red_end_date'].hasError('required')">
              {{ 'MSG_FIELD_REQUIRED' | translate }}
            </mat-error>    
          </mat-form-field>
 
          <!-- redemption_printout_message -->
          <mat-form-field>
            <input 
              id="id_dist_red_msg_txtbox"
              matInput
              #redemption_printout_message 
              autocomplete="off" 
              formControlName="redemption_printout_message" 
              [placeholder]="'LABEL_REDEMPTION_PRINT_MSG' | translate"
              >
   
            <mat-error *ngIf="formGroup.controls['redemption_printout_message'].hasError('maxlength')">
              {{ 'MSG_MAXLENGTH' | translate: {length: '255'} }}
            </mat-error>   
          </mat-form-field>
 
          <!-- reversal_printout_message -->
          <mat-form-field>
            <input 
              id="id_dist_rev_msg_txtbox"
              matInput
              #reversal_printout_message 
              autocomplete="off" 
              formControlName="reversal_printout_message" 
              [placeholder]="'LABEL_REVERSAL_PRINT_MSG' | translate"
              >
   
            <mat-error *ngIf="formGroup.controls['reversal_printout_message'].hasError('maxlength')">
              {{ 'MSG_MAXLENGTH' | translate: {length: '255'} }}
            </mat-error>  
          </mat-form-field>

          <!-- generation_type -->
          <mat-form-field>
                <mat-label>
                  {{ 'LABEL_COUPON_GENERATION_TYPE' | translate }}
                </mat-label>
    
                <mat-select id="id_cgt_dropdown" formControlName="generation_type" required>
                  <mat-option [id]="'id_cgt_data_' + (i+1)" *ngFor="let opt of couponGenerationType; let i = index" [value]="opt">
                    {{opt.description}}
                  </mat-option>
                </mat-select>
    
                <mat-error *ngIf="formGroup.controls['generation_type'].hasError('required')">
                  {{ 'MSG_REQUIRED_FIELD' | translate: {field: 'LABEL_COUPON_GENERATION_TYPE' | translate} }}
                </mat-error>    
          </mat-form-field>

          <!-- pre_generated_qty -->
          <mat-form-field *ngIf="formGroup.get('generation_type').value?.code == 'PG'">
            <input 
              id="id_dist_red_msg_txtbox"
              matInput
              #pre_generated_qty 
              autocomplete="off" 
              formControlName="pre_generated_qty" 
              [placeholder]="'LABEL_PRE_GENERATED' | translate"
              >
   
            <mat-error *ngIf="formGroup.controls['pre_generated_qty'].hasError('required')">
              {{ 'MSG_REQUIRED_FIELD' | translate: {field: 'LABEL_PRE_GENERATED' | translate} }}
            </mat-error>
          </mat-form-field>
          
          <!-- show_groups_in_reports -->
          <div fxLayout="row" fxLayoutAlign="start center">
            <mat-checkbox 
              id="id_show_groups_reports_checkbox"
              formControlName="show_groups_in_reports"
              color="primary">
              Show Groups In Reports
            </mat-checkbox>
          </div>
        </mat-card>
      </div>
 
      <div fxFlex="50" class="padding-5">
        <mat-card fxLayout="column">
          <mat-card-title id="id_cbi_form_header">
            {{ 'LABEL_CAT_BRAND_ITEM' | translate }}
          </mat-card-title>
 
          <!-- cat_brand_item -->
          <mat-form-field>
            <mat-label>
              {{ 'LABEL_CAT_BRAND_ITEM' | translate }}
            </mat-label>
 
            <mat-select id="id_cbi_dropdown" formControlName="cat_brand_item" required>
              <mat-option [id]="'id_cbi_data_' + (i+1)" *ngFor="let opt of catBrandItem; let i = index" [value]="opt">
                {{opt.description}}
              </mat-option>
            </mat-select>
 
            <mat-error *ngIf="formGroup.controls['cat_brand_item'].hasError('required')">
              {{ 'MSG_FIELD_REQUIRED' | translate }}
            </mat-error>    
          </mat-form-field>
 
          <!-- category -->
          <mat-form-field *ngIf="formGroup.get('cat_brand_item').value?.code == '0'">
            <div class="chip-list-container">
              <mat-chip-list #chipsCategory aria-label="Category" required [disabled]="formGroup.get('category').disabled">
                <mat-chip *ngFor="let data of multiSelect.selectedCategories"  [removable]="areChipsRemovable('selectedCategories', data)" (removed)="toggleSelection(data, categorys, 'selectedCategories', 'category')">
                  {{data.description}}
                  <mat-icon *ngIf="areChipsRemovable('selectedCategories', data)" matChipRemove>cancel</mat-icon>
                </mat-chip>
  
                <input 
                  matInput 
                  required
                  #categoryInput
                  formControlName="category"
                  [class.disable]="formGroup.get('category').disabled"
                  [disabled]="formGroup.get('category').disabled"
                  [matAutocomplete]="categoryAC" 
                  [matChipInputFor]="chipsCategory" 
                  [matChipInputAddOnBlur]="true"
                  (focus)="!loading.category && getInitialData('category')" 
                  (blur)="checkAutocompleteObject(formGroup, 'category', 'selectedCategories')"
                  [placeholder]="'LABEL_CATEGORY' | translate" 
                  >
    
                <!-- <mat-icon *ngIf="categoryInput.value" matSuffix svgIcon="close-circle-outline" (click)="resetControl(formGroup.get('category')); categoryInput.value = ''"></mat-icon> -->
  
                <mat-icon 
                  matSuffix 
                  svgIcon="menu-down" 
                  *ngIf="!categoryInput.value" 
                  class="autocomplete-arrow-color cursor-pointer"
                  [class.disable]="formGroup.get('category').disabled"
                  (click)="categoryInput.focus()" 
                  >
                </mat-icon>
              </mat-chip-list>
            </div>

            <mat-autocomplete 
              id="id_cat_dropdown"
              [displayWith]="displayFn"
              #categoryAC="matAutocomplete" 
              (opened)="autocompleteScroll('category','categoryACRef','categoryACTr')"
              >
              <mat-option
                disabled
                *ngIf="!loading.category && categorys?.length == 0"
                >
                {{ 'MSG_NO_DATA' | translate }}
              </mat-option>
 
              <ng-container>
                <mat-option [id]="'id_cat_data_' + (i+1)" *ngFor="let data of categorys; let i = index" [value]="data" [disabled]="data.disabled || !areChipsRemovable('selectedCategories', data)">
                  <div (click)="optionClicked($event, data, categorys, 'selectedCategories', 'category', categoryInput)" [class.disable]="data.disabled || !areChipsRemovable('selectedCategories', data)">
                    <mat-checkbox [id]="'id_cat_data_checkbox_' + (i+1)" [checked]="data.selected" (change)="toggleSelection(data, categorys, 'selectedCategories', 'category', categoryInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled || !areChipsRemovable('selectedCategories', data)">
                      {{ data.description }}
                    </mat-checkbox>
                  </div>
                </mat-option>
              </ng-container>
 
              <mat-option *ngIf="loading.category" disabled>
                <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
              </mat-option>
            </mat-autocomplete> 
          
            <mat-error *ngIf="formGroup.get('category').hasError('required')">
              {{ 'MSG_FIELD_REQUIRED' | translate }}
            </mat-error>
          
            <mat-error *ngIf="formGroup.controls['category'].hasError('notExisting')">
              {{'LABEL_CATEGORY' | translate}} doesn't exist
            </mat-error> 
          </mat-form-field>
 
          <!-- brand -->
          <mat-form-field *ngIf="formGroup.get('cat_brand_item').value?.code == '1'">
            <div class="chip-list-container">
              <mat-chip-list #chipsBrand aria-label="Brand" required [disabled]="formGroup.get('brand').disabled">
                <mat-chip *ngFor="let data of multiSelect.selectedBrands"  [removable]="areChipsRemovable('selectedBrands', data)" (removed)="toggleSelection(data, brands, 'selectedBrands', 'brand')" >
                  {{data.description}}
                  <mat-icon *ngIf="areChipsRemovable('selectedBrands', data)" matChipRemove>cancel</mat-icon>
                </mat-chip>
              
                <input 
                  matInput 
                  required
                  #brandInput
                  formControlName="brand"
                  [class.disable]="formGroup.get('brand').disabled"
                  [disabled]="formGroup.get('brand').disabled"
                  [matAutocomplete]="brandAC" 
                  [matChipInputFor]="chipsBrand" 
                  (focus)="!loading.brand && getInitialData('brand')" 
                  [matChipInputAddOnBlur]="true"
                  (blur)="checkAutocompleteObject(formGroup, 'brand', 'selectedBrands')"
                  [placeholder]="'LABEL_BRAND' | translate" 
                  >
              
                <!-- <mat-icon *ngIf="brandInput.value" matSuffix svgIcon="close-circle-outline" (click)="resetControl(formGroup.get('brand')); brandInput.value = ''"></mat-icon> -->

                <mat-icon 
                  matSuffix 
                  svgIcon="menu-down" 
                  *ngIf="!brandInput.value" 
                  class="autocomplete-arrow-color cursor-pointer"
                  (click)="brandInput.focus()" 
                  [class.disable]="formGroup.get('brand').disabled"
                  >
                </mat-icon>
              </mat-chip-list>
            </div>
            
            <mat-autocomplete 
              id="id_brand_dropdown"
              #brandAC="matAutocomplete" 
              [displayWith]="displayFn"
              (opened)="autocompleteScroll('brand','brandACRef','brandACTr')"
              >
              <mat-option
                disabled
                *ngIf="!loading.brand && brands?.length == 0"
                >
                {{ 'MSG_NO_DATA' | translate }}
              </mat-option>

              <ng-container>       
                <mat-option [id]="'id_brand_data_' + (i+1)" *ngFor="let data of brands; let i = index" [value]="data" [disabled]="data.disabled || !areChipsRemovable('selectedBrands', data)">
                  <div (click)="optionClicked($event, data, brands, 'selectedBrands', 'brand', brandInput)" [class.disable]="data.disabled || !areChipsRemovable('selectedBrands', data)">
                    <mat-checkbox [id]="'id_brand_data_checkbox_' + (i+1)" [checked]="data.selected" (change)="toggleSelection(data, brands, 'selectedBrands', 'brand', brandInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled || !areChipsRemovable('selectedBrands', data)">
                      {{ data.description }}
                    </mat-checkbox>
                  </div>
                </mat-option>
              </ng-container>
            
              <mat-option *ngIf="loading.brand" disabled>
                <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
              </mat-option>
            </mat-autocomplete>
 
            <mat-error *ngIf="formGroup.controls['brand'].hasError('required')">
              {{ 'MSG_FIELD_REQUIRED' | translate }}
            </mat-error> 

            <mat-error *ngIf="formGroup.controls['brand'].hasError('notExisting')">
              {{'LABEL_BRAND' | translate}} doesn't exist
            </mat-error>  
          </mat-form-field>
 
          <!-- item -->
          <mat-form-field *ngIf="formGroup.get('cat_brand_item').value?.code == '2'">
            <div class="chip-list-container">
              <mat-chip-list #chipsItem aria-label="Item" required [disabled]="formGroup.get('item').disabled">
                <mat-chip 
                  *ngFor="let data of multiSelect.selectedItems"  
                  [removable]="areChipsRemovable('selectedItems', data)" 
                  (removed)="toggleSelection(data, items, 'selectedItems', 'item')"
                >
                  {{data.description}}
                  <mat-icon *ngIf="areChipsRemovable('selectedItems', data)" matChipRemove>cancel</mat-icon>
                </mat-chip>
              
                <input 
                  matInput 
                  required
                  #itemInput 
                  formControlName="item" 
                  [matAutocomplete]="itemAC" 
                  [matChipInputFor]="chipsItem" 
                  [class.disable]="formGroup.get('item').disabled"
                  [disabled]="formGroup.get('item').disabled"
                  (focus)="!loading.item && getInitialData('item')" 
                  [matChipInputAddOnBlur]="true"
                  (blur)="checkAutocompleteObject(formGroup, 'item', 'selectedItems')"
                  [placeholder]="'LABEL_ITEM' | translate" 
                  >
              
                <!-- <mat-icon *ngIf="itemInput.value" matSuffix svgIcon="close-circle-outline" (click)="resetControl(formGroup.get('item')); itemInput.value = ''"></mat-icon> -->
              
                <mat-icon 
                  matSuffix 
                  svgIcon="menu-down" 
                  *ngIf="!itemInput.value" 
                  [class.disable]="formGroup.get('item').disabled"
                  class="autocomplete-arrow-color cursor-pointer"
                  (click)="itemInput.focus()" 
                  >
                </mat-icon>
              </mat-chip-list>
            </div>
            
            <mat-autocomplete 
              id="id_item_dropdown"
              [displayWith]="displayFn"
              #itemAC="matAutocomplete" 
              (opened)="autocompleteScroll('item','itemACRef','itemACTr')"
              >
              <mat-option
                disabled
                *ngIf="!loading.item && items?.length == 0"
                >
                {{ 'MSG_NO_DATA' | translate }}
              </mat-option>

              <ng-container>      
                <mat-option [id]="'id_item_data_' + (i+1)" *ngFor="let data of items; let i = index" [value]="data" [disabled]="data.disabled || !areChipsRemovable('selectedItems', data)">
                  <div (click)="optionClicked($event, data, items, 'selectedItems', 'item', itemInput)" [class.disable]="data.disabled || !areChipsRemovable('selectedItems', data)">
                    <mat-checkbox [id]="'id_item_data_checkbox_' + (i+1)" [checked]="data.selected" (change)="toggleSelection(data, items, 'selectedItems', 'item', itemInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled || !areChipsRemovable('selectedItems', data)">
                      {{ data.description }}
                    </mat-checkbox>
                  </div>
                </mat-option>
              </ng-container>
            
              <mat-option *ngIf="loading.item" disabled>
                <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
              </mat-option>
            </mat-autocomplete>
 
            <mat-error *ngIf="formGroup.controls['item'].hasError('required')">
              {{ 'MSG_FIELD_REQUIRED' | translate }}
            </mat-error>    

            <mat-error *ngIf="formGroup.controls['item'].hasError('notExisting')">
              {{'LABEL_ITEM' | translate}} doesn't exist
            </mat-error>
          </mat-form-field>
        </mat-card>
        <div class="padding-5"></div>
        <mat-card fxLayout="column">
          <mat-card-title id="id_cbi_form_header">
            {{ 'LABEL_GROUP' | translate }}
          </mat-card-title>

          <!-- web user group -->
          <mat-form-field>
            <div class="chip-list-container">
              <mat-chip-list #chipsWebUser aria-label="WebUser" required [disabled]="formGroup.get('web_user').disabled">
                <mat-chip *ngFor="let data of multiSelect.selectedWebUser"  [removable]="areChipsRemovable('selectedWebUser', data)" (removed)="toggleSelection(data, web_users, 'selectedWebUser', 'web_user')">
                  {{data.description}}
                  <mat-icon *ngIf="areChipsRemovable('selectedWebUser', data)" matChipRemove>cancel</mat-icon>
                </mat-chip>
  
                <input 
                  matInput 
                  required
                  #web_userInput
                  formControlName="web_user"
                  [class.disable]="formGroup.get('web_user').disabled"
                  [disabled]="formGroup.get('web_user').disabled"
                  [matAutocomplete]="web_userAC" 
                  [matChipInputFor]="chipsWebUser" 
                  [matChipInputAddOnBlur]="true"
                  (focus)="!loading.web_user && getInitialData('web_user')" 
                  (blur)="checkAutocompleteObject(formGroup, 'web_user', 'selectedWebUser')"
                  [placeholder]="'LABEL_WEB_USER' | translate" 
                  >
  
                <mat-icon 
                  matSuffix 
                  svgIcon="menu-down" 
                  *ngIf="!web_userInput.value" 
                  class="autocomplete-arrow-color cursor-pointer"
                  [class.disable]="formGroup.get('web_user').disabled"
                  (click)="web_userInput.focus()" 
                  >
                </mat-icon>
              </mat-chip-list>
            </div>

            <mat-autocomplete 
              id="id_cat_dropdown"
              [displayWith]="displayFn"
              #web_userAC="matAutocomplete" 
              (opened)="autocompleteScroll('web_user','web_userACRef','web_userACTr')"
              >
              <mat-option
                disabled
                *ngIf="!loading.web_user && web_users?.length == 0"
                >
                {{ 'MSG_NO_DATA' | translate }}
              </mat-option>
 
              <ng-container>
                <mat-option [id]="'id_cat_data_' + (i+1)" *ngFor="let data of web_users; let i = index" [value]="data" [disabled]="data.disabled || !areChipsRemovable('selectedWebUser', data)">
                  <div (click)="optionClicked($event, data, web_users, 'selectedWebUser', 'web_user', web_userInput)" [class.disable]="data.disabled || !areChipsRemovable('selectedWebUser', data)">
                    <mat-checkbox [id]="'id_cat_data_checkbox_' + (i+1)" [checked]="data.selected" (change)="toggleSelection(data, web_users, 'selectedWebUser', 'web_user', web_userInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled || !areChipsRemovable('selectedWebUser', data)">
                      {{ data.description }}
                    </mat-checkbox>
                  </div>
                </mat-option>
              </ng-container>
 
              <mat-option *ngIf="loading.web_user" disabled>
                <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
              </mat-option>
            </mat-autocomplete> 
          
            <mat-error *ngIf="formGroup.get('web_user').hasError('required')">
              {{ 'MSG_FIELD_REQUIRED' | translate }}
            </mat-error>
          
            <mat-error *ngIf="formGroup.controls['web_user'].hasError('notExisting')">
              {{'LABEL_WEB_USER' | translate}} doesn't exist
            </mat-error> 
          </mat-form-field>

          <!-- recipient -->
          <mat-form-field>
            <div class="chip-list-container">
              <mat-chip-list #chipsRecipient aria-label="Recipient" required [disabled]="formGroup.get('recipient').disabled">
                <mat-chip *ngFor="let data of multiSelect.selectedRecipient"  [removable]="areChipsRemovable('selectedRecipient', data)" (removed)="toggleSelection(data, recipients, 'selectedRecipient', 'recipient')">
                  {{data.description}}
                  <mat-icon *ngIf="areChipsRemovable('selectedRecipient', data)" matChipRemove>cancel</mat-icon>
                </mat-chip>
  
                <input 
                  matInput 
                  required
                  #recipientInput
                  formControlName="recipient"
                  [class.disable]="formGroup.get('recipient').disabled"
                  [disabled]="formGroup.get('recipient').disabled"
                  [matAutocomplete]="recipientAC" 
                  [matChipInputFor]="chipsRecipient" 
                  [matChipInputAddOnBlur]="true"
                  (focus)="!loading.recipient && getInitialData('recipient')" 
                  (blur)="checkAutocompleteObject(formGroup, 'recipient', 'selectedRecipient')"
                  [placeholder]="'LABEL_RECIPIENT' | translate" 
                  >
    
                <!-- <mat-icon *ngIf="recipientInput.value" matSuffix svgIcon="close-circle-outline" (click)="resetControl(formGroup.get('recipient')); recipientInput.value = ''"></mat-icon> -->
  
                <mat-icon 
                  matSuffix 
                  svgIcon="menu-down" 
                  *ngIf="!recipientInput.value" 
                  class="autocomplete-arrow-color cursor-pointer"
                  [class.disable]="formGroup.get('recipient').disabled"
                  (click)="recipientInput.focus()" 
                  >
                </mat-icon>
              </mat-chip-list>
            </div>

            <mat-autocomplete 
              id="id_cat_dropdown"
              [displayWith]="displayFn"
              #recipientAC="matAutocomplete" 
              (opened)="autocompleteScroll('recipient','recipientACRef','recipientACTr')"
              >
              <mat-option
                disabled
                *ngIf="!loading.recipient && recipients?.length == 0"
                >
                {{ 'MSG_NO_DATA' | translate }}
              </mat-option>
 
              <ng-container>
                <mat-option [id]="'id_cat_data_' + (i+1)" *ngFor="let data of recipients; let i = index" [value]="data" [disabled]="data.disabled || !areChipsRemovable('selectedRecipient', data)">
                  <div (click)="optionClicked($event, data, recipients, 'selectedRecipient', 'recipient', recipientInput)" [class.disable]="data.disabled || !areChipsRemovable('selectedRecipient', data)">
                    <mat-checkbox [id]="'id_cat_data_checkbox_' + (i+1)" [checked]="data.selected" (change)="toggleSelection(data, recipients, 'selectedRecipient', 'recipient', recipientInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled || !areChipsRemovable('selectedRecipient', data)">
                      {{ data.description }}
                    </mat-checkbox>
                  </div>
                </mat-option>
              </ng-container>
 
              <mat-option *ngIf="loading.recipient" disabled>
                <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
              </mat-option>
            </mat-autocomplete> 
          
            <mat-error *ngIf="formGroup.get('recipient').hasError('required')">
              {{ 'MSG_FIELD_REQUIRED' | translate }}
            </mat-error>
          
            <mat-error *ngIf="formGroup.controls['recipient'].hasError('notExisting')">
              {{'LABEL_RECIPIENT' | translate}} doesn't exist
            </mat-error> 
          </mat-form-field>

        </mat-card>
      </div>

    </div>
 
    <div fxFlex fxLayout fxLayoutGap="15px">
      <div fxFlex class="padding-5">
        <mat-card fxLayout="column">
          <mat-card-title id="id_branch_form_header">
            {{ 'LABEL_BRANCH' | translate }}
          </mat-card-title>
  
          <div fxLayout fxLayout.lt-md="column" fxLayoutGap="15px">
            <div fxFlex="50">
              <!-- location_region -->
              <mat-form-field>
                <div class="chip-list-container">
                  <mat-chip-list #chipsRegion aria-label="Region" required [disabled]="formGroup.get('location_region').disabled">
                    <mat-chip *ngFor="let data of multiSelect.selectedRegions"  [removable]="areChipsRemovable('selectedRegions', data)" (removed)="toggleSelection(data, location_regions, 'selectedRegions', 'location_region')">
                      {{data.description}}
                      <mat-icon *ngIf="areChipsRemovable('selectedRegions', data)" matChipRemove>cancel</mat-icon>
                    </mat-chip>
                  
                    <input 
                      matInput 
                      required
                      #location_regionInput 
                      [matChipInputFor]="chipsRegion" 
                      formControlName="location_region" 
                      [matChipInputAddOnBlur]="true"
                      [class.disable]="formGroup.get('location_region').disabled"
                      [disabled]="formGroup.get('location_region').disabled"
                      [matAutocomplete]="location_regionAC" 
                      (focus)="!loading.location_region && getInitialData('location_region')" 
                      (blur)="checkAutocompleteObject(formGroup, 'location_region', 'selectedRegions')"
                      [placeholder]="'LABEL_LOCATION_REGION' | translate" 
                      >
                  
                    <!-- <mat-icon *ngIf="location_regionInput.value" matSuffix svgIcon="close-circle-outline" (click)="resetControl(formGroup.get('location_region')); location_regionInput.value = ''"></mat-icon> -->
                  
                    <mat-icon 
                      matSuffix 
                      svgIcon="menu-down" 
                      *ngIf="!location_regionInput.value" 
                      [class.disable]="formGroup.get('location_region').disabled"
                      class="autocomplete-arrow-color cursor-pointer"
                      (click)="location_regionInput.focus()" 
                      >
                    </mat-icon>
                  </mat-chip-list>
                </div>
                
                <mat-autocomplete 
                  id="id_branch_region_dropdown"
                  [displayWith]="displayFn"
                  #location_regionAC="matAutocomplete" 
                  (opened)="autocompleteScroll('location_region','regionACRef','regionACTr')"
                  >
                  <mat-option
                    disabled
                    *ngIf="!loading.location_region && location_regions?.length == 0"
                    >
                    {{ 'MSG_NO_DATA' | translate }}
                  </mat-option>

                  <ng-container>
                    <mat-option [id]="'id_branch_region_data_' + (i+1)" *ngFor="let data of location_regions; let i = index" [value]="data" [disabled]="data.disabled || !areChipsRemovable('selectedRegions', data)">
                      <div (click)="optionClicked($event, data, location_regions, 'selectedRegions', 'location_region', location_regionInput)" [class.disable]="data.disabled || !areChipsRemovable('selectedRegions', data)">
                        <mat-checkbox [id]="'id_branch_region_data_checkbox' + (i+1)" [checked]="data.selected" (change)="toggleSelection(data, location_regions, 'selectedRegions', 'location_region', location_regionInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled || !areChipsRemovable('selectedRegions', data)">
                          {{ data.description }}
                        </mat-checkbox>
                      </div>
                    </mat-option>
                  </ng-container>
                
                  <mat-option *ngIf="loading.location_region" disabled>
                    <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
                  </mat-option>
                </mat-autocomplete>
    
                <mat-error *ngIf="formGroup.controls['location_region'].hasError('required')">
                  {{ 'MSG_FIELD_REQUIRED' | translate }}
                </mat-error>    

                <mat-error *ngIf="formGroup.controls['location_region'].hasError('notExisting')">
                  {{'LABEL_LOCATION_REGION' | translate}} doesn't exist
                </mat-error>
              </mat-form-field>
      
              <!-- location_province -->
              <mat-form-field>
                <div class="chip-list-container">
                  <mat-chip-list #chipsProvince aria-label="Province" required [disabled]="formGroup.get('location_province').disabled">
                    <mat-chip *ngFor="let data of multiSelect.selectedProvinces"  [removable]="areChipsRemovable('selectedProvinces', data)" (removed)="toggleSelection(data, location_provinces, 'selectedProvinces', 'location_province')">
                      {{data.description}}
                      <mat-icon *ngIf="areChipsRemovable('selectedProvinces', data)" matChipRemove>cancel</mat-icon>
                    </mat-chip>
                  
                    <input 
                      matInput 
                      required
                      #location_provinceInput 
                      [matChipInputFor]="chipsProvince" 
                      formControlName="location_province" 
                      [matChipInputAddOnBlur]="true"
                      [class.disable]="formGroup.get('location_province').disabled"
                      [disabled]="formGroup.get('location_province').disabled"
                      [matAutocomplete]="location_provinceAC" 
                      (focus)="!loading.location_province && getInitialData('location_province')" 
                      (blur)="checkAutocompleteObject(formGroup, 'location_province', 'selectedProvinces')"
                      [placeholder]="'LABEL_LOCATION_PROVINCE' | translate" 
                      >
                  
                    <!-- <mat-icon *ngIf="location_provinceInput.value" matSuffix svgIcon="close-circle-outline" (click)="resetControl(formGroup.get('location_province')); location_provinceInput.value = ''"></mat-icon> -->
                  
                    <mat-icon 
                      matSuffix 
                      svgIcon="menu-down" 
                      *ngIf="!location_provinceInput.value" 
                      [class.disable]="formGroup.get('location_province').disabled"
                      class="autocomplete-arrow-color cursor-pointer"
                      (click)="location_provinceInput.focus()" 
                      >
                    </mat-icon>
                  </mat-chip-list>
                </div>
                
                <mat-autocomplete 
                  id="id_branch_province_dropdown"
                  [displayWith]="displayFn"
                  #location_provinceAC="matAutocomplete" 
                  (opened)="autocompleteScroll('location_province','provinceACRef','provinceACTr')"
                  >
                  <mat-option
                    disabled
                    *ngIf="!loading.location_province && location_provinces?.length == 0"
                    >
                    {{ 'MSG_NO_DATA' | translate }}
                  </mat-option>

                  <ng-container>
                    <mat-option [id]="'id_branch_province_data_' + (i+1)" *ngFor="let data of location_provinces; let i = index" [value]="data" [disabled]="data.disabled || !areChipsRemovable('selectedProvinces', data)">
                      <div (click)="optionClicked($event, data, location_provinces, 'selectedProvinces', 'location_province', location_provinceInput)" [class.disable]="data.disabled || !areChipsRemovable('selectedProvinces', data)">
                        <mat-checkbox [id]="'id_branch_province_data_checkbox' + (i+1)" [checked]="data.selected" (change)="toggleSelection(data, location_provinces, 'selectedProvinces', 'location_province', location_provinceInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled || !areChipsRemovable('selectedProvinces', data)">
                          {{ data.description }}
                        </mat-checkbox>
                      </div>
                    </mat-option>
                  </ng-container>
 
                  <mat-option *ngIf="loading.location_province" disabled>
                    <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
                  </mat-option>
                </mat-autocomplete>
    
                <mat-error *ngIf="formGroup.controls['location_province'].hasError('required')">
                  {{ 'MSG_FIELD_REQUIRED' | translate }}
                </mat-error>  

                <mat-error *ngIf="formGroup.controls['location_province'].hasError('notExisting')">
                  {{'LABEL_LOCATION_PROVINCE' | translate}} doesn't exist
                </mat-error> 
              </mat-form-field>
      
              <!-- location_city -->
              <mat-form-field>
                <div class="chip-list-container">
                  <mat-chip-list #chipsCity aria-label="City" required [disabled]="formGroup.get('location_city').disabled">
                    <mat-chip *ngFor="let data of multiSelect.selectedCities"  [removable]="areChipsRemovable('selectedCities', data)" (removed)="toggleSelection(data, location_citys, 'selectedCities', 'location_city')">
                      {{data.description}}
                      <mat-icon *ngIf="areChipsRemovable('selectedCities', data)" matChipRemove>cancel</mat-icon>
                    </mat-chip>
                  
                    <input 
                      matInput 
                      required
                      #location_cityInput 
                      [matChipInputFor]="chipsCity" 
                      formControlName="location_city" 
                      [matChipInputAddOnBlur]="true"
                      [matAutocomplete]="location_cityAC" 
                      [class.disable]="formGroup.get('location_city').disabled"
                      [disabled]="formGroup.get('location_city').disabled"
                      (focus)="!loading.location_city && getInitialData('location_city')" 
                      (blur)="checkAutocompleteObject(formGroup, 'location_city', 'selectedCities')"
                      [placeholder]="'LABEL_LOCATION_CITY' | translate" 
                      >
                  
                    <!-- <mat-icon *ngIf="location_cityInput.value" matSuffix svgIcon="close-circle-outline" (click)="resetControl(formGroup.get('location_city')); location_cityInput.value = ''"></mat-icon> -->
                  
                    <mat-icon 
                      matSuffix 
                      svgIcon="menu-down" 
                      *ngIf="!location_cityInput.value" 
                      [class.disable]="formGroup.get('location_city').disabled"
                      class="autocomplete-arrow-color cursor-pointer"
                      (click)="location_cityInput.focus()" 
                      >
                    </mat-icon>
                  </mat-chip-list>
                </div>
                
                <mat-autocomplete 
                  id="id_branch_city_dropdown"
                  [displayWith]="displayFn" 
                  #location_cityAC="matAutocomplete" 
                  (opened)="autocompleteScroll('location_city','cityACRef','cityACTr')"
                  >
                  <mat-option
                    disabled
                    *ngIf="!loading.location_city && location_citys?.length == 0"
                    >
                    {{ 'MSG_NO_DATA' | translate }}
                  </mat-option>

                  <ng-container>
                    <mat-option [id]="'id_branch_city_data_' + (i+1)" *ngFor="let data of location_citys; let i = index" [value]="data" [disabled]="data.disabled || !areChipsRemovable('selectedCities', data)" [hidden]="loading.location_city">
                      <div (click)="optionClicked($event, data, location_citys, 'selectedCities', 'location_city', location_cityInput)" [class.disable]="data.disabled || !areChipsRemovable('selectedCities', data)">
                        <mat-checkbox [id]="'id_branch_city_data_checkbox' + (i+1)" [checked]="data.selected" (change)="toggleSelection(data, location_citys, 'selectedCities', 'location_city', location_cityInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled || !areChipsRemovable('selectedCities', data)">
                          {{ data.description }}
                        </mat-checkbox>
                      </div>
                    </mat-option>
                  </ng-container>
                
                  <mat-option *ngIf="loading.location_city" disabled>
                    <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
                  </mat-option>
                </mat-autocomplete>
    
                <mat-error *ngIf="formGroup.controls['location_city'].hasError('required')">
                  {{ 'MSG_FIELD_REQUIRED' | translate }}
                </mat-error>  

                <mat-error *ngIf="formGroup.controls['location_city'].hasError('notExisting')">
                  {{'LABEL_LOCATION_CITY' | translate}} doesn't exist
                </mat-error> 
              </mat-form-field>
            </div>
 
            <mat-divider vertical="true"></mat-divider>
 
            <div fxFlex="50">
              <!-- chain_type -->
              <mat-form-field>
                <div class="chip-list-container">
                  <mat-chip-list #chipsChainType aria-label="Chain Type" required [disabled]="formGroup.get('chain_type').disabled">
                    <mat-chip *ngFor="let data of multiSelect.selectedChainTypes"  [removable]="areChipsRemovable('selectedChainTypes', data)" (removed)="toggleSelection(data, chain_types, 'selectedChainTypes', 'chain_type')">
                      {{data.description}}
                      <mat-icon *ngIf="areChipsRemovable('selectedChainTypes', data)" matChipRemove>cancel</mat-icon>
                    </mat-chip>
                  
                    <input 
                      matInput 
                      required
                      #chainTypeInput 
                      formControlName="chain_type" 
                      [matAutocomplete]="chain_typeAC" 
                      [matChipInputFor]="chipsChainType" 
                      [matChipInputAddOnBlur]="true"
                      [class.disable]="formGroup.get('chain_type').disabled"
                      [disabled]="formGroup.get('chain_type').disabled"
                      (focus)="!loading.chain_type && getInitialData('chain_type')" 
                      (blur)="checkAutocompleteObject(formGroup, 'chain_type', 'selectedChainTypes')"
                      [placeholder]="'LABEL_CHAIN_TYPE' | translate" 
                      >
                  
                    <!-- <mat-icon *ngIf="chainTypeInput.value" matSuffix svgIcon="close-circle-outline" (click)="resetControl(formGroup.get('chain_type')); chainTypeInput.value = ''"></mat-icon> -->
                  
                    <mat-icon 
                      matSuffix 
                      svgIcon="menu-down" 
                      *ngIf="!chainTypeInput.value" 
                      [class.disable]="formGroup.get('chain_type').disabled"
                      class="autocomplete-arrow-color cursor-pointer"
                      (click)="chainTypeInput.focus()" 
                      >
                    </mat-icon>
                  </mat-chip-list>
                </div>
                
                <mat-autocomplete 
                  id="id_branch_chain_type_dropdown"
                  [displayWith]="displayFn"
                  #chain_typeAC="matAutocomplete" 
                  (opened)="autocompleteScroll('chain_type','chain_typeACRef','chain_typeACTr')"
                  >
                  <mat-option
                    disabled
                    *ngIf="!loading.chain_type && chain_types?.length == 0"
                    >
                    {{ 'MSG_NO_DATA' | translate }}
                  </mat-option>

                  <ng-container>      
                    <mat-option [id]="'id_branch_chain_type_data_' + (i+1)" *ngFor="let data of chain_types; let i = index" [value]="data" [disabled]="data.disabled || !areChipsRemovable('selectedChainTypes', data)">
                      <div (click)="optionClicked($event, data, chain_types, 'selectedChainTypes', 'chain_type', chainTypeInput)" [class.disable]="data.disabled || !areChipsRemovable('selectedChainTypes', data)">
                        <mat-checkbox [id]="'id_branch_chain_type_data_checkbox' + (i+1)" [checked]="data.selected" (change)="toggleSelection(data, chain_types, 'selectedChainTypes', 'chain_type', chainTypeInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled || !areChipsRemovable('selectedChainTypes', data)">
                          {{ data.description }}
                        </mat-checkbox>
                      </div>
                    </mat-option>
                  </ng-container>
                
                  <mat-option *ngIf="loading.chain_type" disabled>
                    <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
                  </mat-option>
                </mat-autocomplete>
        
                <mat-error *ngIf="formGroup.controls['chain_type'].hasError('required')">
                  {{ 'MSG_FIELD_REQUIRED' | translate }}
                </mat-error>    

                <mat-error *ngIf="formGroup.controls['chain_type'].hasError('notExisting')">
                  {{'LABEL_CHAIN_TYPE' | translate}} doesn't exist
                </mat-error> 
              </mat-form-field>
        
              <!-- chain -->
              <mat-form-field>
                <div class="chip-list-container">
                  <mat-chip-list #chipsChain aria-label="Chain" required [disabled]="formGroup.get('chain').disabled">
                    <mat-chip *ngFor="let data of multiSelect.selectedChains"  [removable]="areChipsRemovable('selectedChains', data)" (removed)="toggleSelection(data, chains, 'selectedChains', 'chain')">
                      {{data.description}}
                      <mat-icon *ngIf="areChipsRemovable('selectedChains', data)" matChipRemove>cancel</mat-icon>
                    </mat-chip>
                  
                    <input 
                      matInput 
                      required
                      #chainInput 
                      formControlName="chain" 
                      [matAutocomplete]="chainAC" 
                      [matChipInputFor]="chipsChain" 
                      [class.disable]="formGroup.get('chain').disabled"
                      [disabled]="formGroup.get('chain').disabled"
                      (focus)="!loading.chain && getInitialData('chain')" 
                      (blur)="checkAutocompleteObject(formGroup, 'chain', 'selectedChains')"
                      [matChipInputAddOnBlur]="true"
                      [placeholder]="'LABEL_CHAIN' | translate" 
                      >
                  
                    <!-- <mat-icon *ngIf="chainInput.value" matSuffix svgIcon="close-circle-outline" (click)="resetControl(formGroup.get('chain')); chainInput.value = ''"></mat-icon> -->

                    <mat-icon 
                      matSuffix 
                      svgIcon="menu-down" 
                      *ngIf="!chainInput.value" 
                      [class.disable]="formGroup.get('chain').disabled"
                      class="autocomplete-arrow-color cursor-pointer"
                      (click)="chainInput.focus()" 
                      >
                    </mat-icon>
                  </mat-chip-list>
                </div>
                
                <mat-autocomplete 
                  id="id_branch_chain_dropdown"
                  [displayWith]="displayFn"
                  #chainAC="matAutocomplete" 
                  (opened)="autocompleteScroll('chain','chainACRef','chainACTr')"
                  >
                  <mat-option
                    disabled
                    *ngIf="!loading.chain && chains?.length == 0"
                    >
                    {{ 'MSG_NO_DATA' | translate }}
                  </mat-option>

                  <ng-container>
                    <mat-option [id]="'id_branch_chain_data_' + (i+1)" *ngFor="let data of chains; let i = index" [value]="data" [disabled]="data.disabled || !areChipsRemovable('selectedChains', data)">
                      <div (click)="optionClicked($event, data, chains, 'selectedChains', 'chain', chainInput)" [class.disable]="data.disabled || !areChipsRemovable('selectedChains', data)">
                        <mat-checkbox [id]="'id_branch_chain_data_checkbox' + (i+1)" [checked]="data.selected" (change)="toggleSelection(data, chains, 'selectedChains', 'chain', chainInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled || !areChipsRemovable('selectedChains', data)">
                          {{ data.description }}
                        </mat-checkbox>
                      </div>
                    </mat-option>
                  </ng-container>
 
                  <mat-option *ngIf="loading.chain" disabled>
                    <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
                  </mat-option>
                </mat-autocomplete>
        
                <mat-error *ngIf="formGroup.controls['chain'].hasError('required')">
                  {{ 'MSG_FIELD_REQUIRED' | translate }}
                </mat-error>     

                <mat-error *ngIf="formGroup.controls['chain'].hasError('notExisting')">
                  {{'LABEL_CHAIN' | translate}} doesn't exist
                </mat-error> 
              </mat-form-field>
        
              <!-- branch -->
              <mat-form-field>
                <div class="chip-list-container">
                  <mat-chip-list #chipsBranch aria-label="Branch" required [disabled]="formGroup.get('branch').disabled">
                    <mat-chip *ngFor="let data of multiSelect.selectedBranch"  [removable]="areChipsRemovable('selectedBranch', data)" (removed)="toggleSelection(data, branches, 'selectedBranch', 'branch')">
                      {{data.description}}
                      <mat-icon *ngIf="areChipsRemovable('selectedBranch', data)" matChipRemove>cancel</mat-icon>
                    </mat-chip>
                  
                    <input 
                      matInput 
                      required
                      #branchInput 
                      formControlName="branch" 
                      [matAutocomplete]="branchAC" 
                      [matChipInputFor]="chipsBranch" 
                      [class.disable]="formGroup.get('branch').disabled"
                      [disabled]="formGroup.get('branch').disabled"
                      (focus)="!loading.branch && getInitialData('branch')" 
                      (blur)="checkAutocompleteObject(formGroup, 'branch', 'selectedBranch')"
                      [matChipInputAddOnBlur]="true"
                      [placeholder]="'LABEL_BRANCH' | translate" 
                      >
                  
                    <!-- <mat-icon *ngIf="branchInput.value" matSuffix svgIcon="close-circle-outline" (click)="resetControl(formGroup.get('branch')); branchInput.value = ''"></mat-icon> -->
                  
                    <mat-icon 
                      matSuffix 
                      svgIcon="menu-down" 
                      *ngIf="!branchInput.value" 
                      [class.disable]="formGroup.get('branch').disabled"
                      class="autocomplete-arrow-color cursor-pointer"
                      (click)="branchInput.focus()" 
                      >
                    </mat-icon>
                  </mat-chip-list>
                </div>
                
                <mat-autocomplete 
                  id="id_branch_dropdown"
                  [displayWith]="displayFn"
                  #branchAC="matAutocomplete" 
                  (opened)="autocompleteScroll('branch','branchACRef','branchACTr')"
                  >
                  <mat-option
                    disabled
                    *ngIf="!loading.branch && branches?.length == 0"
                    >
                    {{ 'MSG_NO_DATA' | translate }}
                  </mat-option>
                  
                  <ng-container>
                    <mat-option [id]="'id_branch_data_' + (i+1)" *ngFor="let data of branches; let i = index" [value]="data" [disabled]="data.disabled || !areChipsRemovable('selectedBranch', data)">
                      <div (click)="optionClicked($event, data, branches, 'selectedBranch', 'branch', branchInput)" [class.disable]="data.disabled || !areChipsRemovable('selectedBranch', data)">
                        <mat-checkbox [id]="'id_branch_data_checkbox' + (i+1)" [checked]="data.selected" (change)="toggleSelection(data, branches, 'selectedBranch', 'branch', branchInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled || !areChipsRemovable('selectedBranch', data)">
                          {{ data.description }}
                        </mat-checkbox>
                      </div>
                    </mat-option>
                  </ng-container>
                
                  <mat-option *ngIf="loading.branch" disabled>
                    <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
                  </mat-option>
                </mat-autocomplete>
        
                <mat-error *ngIf="formGroup.controls['branch'].hasError('required')">
                  {{ 'MSG_FIELD_REQUIRED' | translate }}
                </mat-error>   

                <mat-error *ngIf="formGroup.controls['branch'].hasError('notExisting')">
                  {{'LABEL_BRANCH' | translate}} doesn't exist
                </mat-error>  
              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
 
    <div fxFlex fxLayout fxLayoutGap="15px">
      <div fxFlex class="padding-5">
        <mat-card fxLayout="column">
          <mat-card-title id="id_coupon_form_header">
            {{ 'LABEL_COUPON' | translate }}
          </mat-card-title>
          
          <div fxLayout fxLayout.lt-md="column" fxLayoutGap="15px">
            <div fxFlex="50">
              <h3 id="id_coupon_act_sub_header" class="sub-header">
                {{ 'LABEL_ACTIVATION' | translate }}
              </h3>
              <!-- act_type -->
              <mat-form-field>        
                <mat-label>
                  {{ 'LABEL_ACTIVATION' | translate }}
                </mat-label>
        
                <mat-select id="id_coupon_act_dropdown" formControlName="act_type" required>
                  <mat-option [id]="'id_coupon_act_data_' + (i+1)" *ngFor="let opt of actTypes; let i = index" [value]="opt.code">
                    {{opt.description}}
                  </mat-option>
                </mat-select>
        
                <mat-error *ngIf="formGroup.controls['act_type'].hasError('required')">
                  {{ 'MSG_FIELD_REQUIRED' | translate }}
                </mat-error>    
              </mat-form-field>
  
              <!-- reg_deadline -->
              <mat-form-field> 
                <input 
                  id="id_reg_deadline_date"
                  matInput 
                  required 
                  readonly
                  (click)="reg_deadline.open()" 
                  [matDatepicker]="reg_deadline" 
                  formControlName="reg_deadline" 
                  [min]="minDate"
                  [max]="maxDate" 
                  [placeholder]="'LABEL_REG_DEADLINE' | translate" 
                  >
    
                <mat-datepicker-toggle id="id_reg_deadline_date_btn" matSuffix [for]="reg_deadline"></mat-datepicker-toggle>
                <mat-datepicker #reg_deadline></mat-datepicker>  
    
                <mat-error *ngIf="formGroup.controls['reg_deadline'].hasError('required')">
                  {{ 'MSG_FIELD_REQUIRED' | translate }}
                </mat-error> 
              </mat-form-field>
  
              <!-- num_of_txn -->
              <mat-form-field>
                <input 
                  id="id_num_txn_txtbox"
                  matInput
                  required
                  #on_demand
                  autocomplete="off" 
                  formControlName="num_of_txn" 
                  [placeholder]="'LABEL_NUM_OF_TXN' | translate"
                  >
      
                <mat-error *ngIf="formGroup.controls['num_of_txn'].hasError('required')">
                  {{ 'MSG_FIELD_REQUIRED' | translate }}
                </mat-error>  
                       
                <mat-error *ngIf="formGroup.controls['num_of_txn'].hasError('pattern')">
                  {{ 'MSG_NUMBERS_ONLY' | translate }}
                </mat-error>   

                <mat-error *ngIf="formGroup.controls['num_of_txn'].hasError('min')">
                  {{ 'MSG_MIN' | translate: {quantity: '0'} }}
                </mat-error> 
              </mat-form-field>

              <!-- Checkbox here -->
              <div class="toggle-container" fxLayout="column">
                <span class="label">Coupon Status</span>
                <mat-slide-toggle formControlName="generate_active_coupon" color="primary">
                  {{ formGroup.get('generate_active_coupon')?.value ? 'Active' : 'Inactive' }}
                </mat-slide-toggle>
              </div>
            </div>
            
            <mat-divider vertical="media.isActive('gt-sm')"></mat-divider>
            
            <div fxFlex="50">
              <h3 id="id_coupon_exp_sub_header" class="sub-header">
                {{ 'LABEL_EXPIRATION' | translate }}
              </h3>
              <!-- exp_type -->
              <mat-form-field>        
                <mat-label>
                  {{ 'LABEL_EXPIRATION' | translate }}
                </mat-label>
        
                <mat-select id="id_coupon_exp_dropdown" formControlName="exp_type" required>
                  <mat-option [id]="'id_coupon_exp_data_' + (i+1)" *ngFor="let opt of expTypes; let i = index" [value]="opt.code">
                    {{opt.description}}
                  </mat-option>
                </mat-select>
        
                <mat-error *ngIf="formGroup.controls['exp_type'].hasError('required')">
                  {{ 'MSG_FIELD_REQUIRED' | translate }}
                </mat-error>    
              </mat-form-field>
  
              <!-- exp_date -->
              <mat-form-field> 
                <input 
                  id="id_exp_date"
                  matInput 
                  required 
                  readonly
                  (click)="exp_date.open()" 
                  [matDatepicker]="exp_date" 
                  formControlName="exp_date" 
                  [min]="minExpiryDate"
                  [max]="maxExpiryDate"
                  [placeholder]="'LABEL_EXP_DATE' | translate" 
                  >
    
                <mat-datepicker-toggle id="id_exp_date_btn" matSuffix [for]="exp_date"></mat-datepicker-toggle>
                <mat-datepicker #exp_date></mat-datepicker>  
    
                <mat-error *ngIf="formGroup.controls['exp_date'].hasError('required')">
                  {{ 'MSG_FIELD_REQUIRED' | translate }}
                </mat-error> 
              </mat-form-field>
  
              <!-- num_of_days -->
              <mat-form-field>
                <input 
                  id="id_num_days_txtbox"
                  matInput
                  required
                  autocomplete="off" 
                  formControlName="num_of_days" 
                  [placeholder]="'LABEL_NUM_OF_DAYS' | translate"
                  >
      
                <mat-error *ngIf="formGroup.controls['num_of_days'].hasError('required')">
                  {{ 'MSG_FIELD_REQUIRED' | translate }}
                </mat-error>   
                       
                <mat-error *ngIf="formGroup.controls['num_of_days'].hasError('pattern')">
                  {{ 'MSG_NUMBERS_ONLY' | translate }}
                </mat-error>  

                <mat-error *ngIf="formGroup.controls['num_of_days'].hasError('min')">
                  {{ 'MSG_MIN' | translate: {quantity: '1'} }}
                </mat-error>

              </mat-form-field>
  
              <!-- num_of_days_from_first_purchase -->
              <mat-form-field>
                <input 
                  id="id_num_days_first_purch_txtbox"
                  matInput
                  required
                  autocomplete="off" 
                  formControlName="num_of_days_from_first_purchase" 
                  [placeholder]="'LABEL_NUM_OF_DAYS_FIRST_PURCH' | translate"
                  >
      
                <mat-error *ngIf="formGroup.controls['num_of_days_from_first_purchase'].hasError('required')">
                  {{ 'MSG_FIELD_REQUIRED' | translate }}
                </mat-error>   
                        
                <mat-error *ngIf="formGroup.controls['num_of_days_from_first_purchase'].hasError('pattern')">
                  {{ 'MSG_NUMBERS_ONLY' | translate }}
                </mat-error>    
              
                <mat-error *ngIf="formGroup.controls['num_of_days_from_first_purchase'].hasError('min')">
                  {{ 'MSG_MIN' | translate: {quantity: '1'} }}
                </mat-error> 
              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
 
    <div fxFlex fxLayout fxLayoutGap="15px">
      <div fxFlex fxLayoutAlign="center center" class="padding-5">
        <label id="id_is_cancel_lbl" class="color-gray">
          {{ 'LABEL_CANCELLED' | translate }}
        </label>
        <mat-slide-toggle id="id_is_cancel_toggle" class="padding-left-5" #toggle1 color="primary" formControlName="is_cancelled">
        </mat-slide-toggle>
      </div>
    </div>
  </div>
 
  <div *ngIf="loadingDistribution" fxLayout="column" fxLayoutAlign="center center" class="loading-indicator-wizard">
    <mat-spinner></mat-spinner>
  </div>
</form>